import React from "react";
import { Tooltip } from "react-leaflet";

interface MarkerTooltipProps {
  street: string;
  city: string;
  pincode: string;
  markerPosition: [number, number];
  isSubmitting: boolean;
  t: (key: string) => string;
  openGoogleMaps: (lat: number, lng: number) => void;
  goToMapAddAddress: (lat: number, lng: number) => void;
  fetchAddresses: () => void;
  onClose: () => void;
}

const MarkerTooltip: React.FC<MarkerTooltipProps> = ({
  street,
  city,
  pincode,
  markerPosition,
  isSubmitting,
  t,
  openGoogleMaps,
  goToMapAddAddress,
  fetchAddresses,
  onClose,
}) => {
  return (
    <Tooltip direction="top" offset={[0, -45]} opacity={1} interactive permanent>
      <button
          className="absolute top-1 right-1 text-gray-400 hover:text-blue-500 focus:outline-none text-xs sm:text-sm"
          style={{ zIndex: 10 }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          aria-label="Close"
        >
          &#10005;
        </button>
      <div className="flex flex-col gap-2 w-full sm:min-w-[250px] sm:max-w-[350px] bg-gradient-to-r from-white to-blue-50 rounded-xl p-1 sm:p-2 md:p-2 shadow-2xl relative">
        
        <div
          className="max-h-[60px] overflow-y-auto"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <p className="text-[10px] sm:text-sm font-semibold text-gray-800 break-words whitespace-pre-wrap">
            {street}, {city}, {pincode}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 mt-2 border-t border-gray-200 pt-1 sm:pt-2">
          <button
            className="flex-1 flex items-center justify-center px-1 py-1 sm:px-2 sm:py-1 rounded bg-white hover:bg-blue-100 border border-transparent hover:border-blue-300 transition-all duration-300 group shadow-sm"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const [lat, lng] = markerPosition;
              openGoogleMaps(lat, lng);
            }}
          >
            <span className="text-[8px] sm:text-xs font-medium text-blue-600 truncate group-hover:text-blue-700">
              {t("navigate")}
            </span>
          </button>
          <button
            className="flex-1 flex items-center justify-center px-1 py-1 sm:px-2 sm:py-1 rounded bg-white hover:bg-blue-100 border border-transparent hover:border-blue-300 transition-all duration-300 group shadow-sm"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const [lat, lng] = markerPosition;
              goToMapAddAddress(lat, lng);
            }}
          >
            <span className="text-[8px] sm:text-xs font-medium text-blue-600 truncate group-hover:text-blue-700">
              {t("addAddress")}
            </span>
          </button>
          <button
            className="flex-1 flex items-center justify-center px-1 py-1 sm:px-2 sm:py-1 rounded bg-white hover:bg-blue-100 border border-transparent hover:border-blue-300 transition-all duration-300 group shadow-sm"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              fetchAddresses();
            }}
          >
            <span className="text-[8px] sm:text-xs font-medium text-blue-600 truncate group-hover:text-blue-700">
              {isSubmitting ? t("viewing") : t("view")}
            </span>
          </button>
        </div>
      </div>
    </Tooltip>
  );
};

export default MarkerTooltip;
